<template>
    <div>
        <p class="accordion-body-heading mr-2" v-bind:class="{'mt-2': nakdanType.Simple}">
            <span v-if="nakdanType.Simple">בחרו את סגנון הטקסט שתרצו לנקד:</span>
            <span v-else>בחר את סגנון הטקסט אותו תרצה לנקד:</span>
        </p>
        <ul class="chapter2 list-unstyled accordion-list">
            <li v-for="(textType, textTypeIndex) in textTypes"
                :key="textTypeIndex" @click="chosenTextTypeIndex=textTypeIndex">
                <b-form-radio v-bind:id="'use-' + textType.name + '-nakdan'"
                                v-bind:value="textTypeIndex"
                                v-model="chosenTextTypeIndex">{{ textType.displayText }}
                </b-form-radio>
            </li>
        </ul>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {AppConfig as appConfig} from '../appConfig'
    import {NakdanType} from '@/simpleVsProConfig.js'

    const textTypes = [
                    {
                        name: 'modern',
                        displayText: 'טקסט מודרני'
                    },
                    {
                        name: 'rabbinic',
                        displayText: 'טקסט רבני'
                    },
                    {
                        name: 'poetry',
                        displayText: 'טקסט שירה'
                    }
                ]
    if (appConfig.INCLUDE_TALMUD_GENRE) textTypes.push({
        name: 'talmud',
        displayText: 'טקסט מהתלמוד'
    })

    export default {
        name: 'DocumentSettingsGenre',
        data() {
            return {
                chosenTextTypeIndex: textTypes.map(t => t.name).indexOf(this.options.chosenTextTypeName),
                textTypes: textTypes
            }
        },
        props: ['options'],
        computed: {
            nakdanType () {
                return NakdanType
            },
            chosenTextType: function () {
                return this.textTypes[this.chosenTextTypeIndex]
            }
        },
        watch: {
            chosenTextTypeIndex(newChosenTextTypeIndex) {
                this.options.chosenTextTypeName = this.textTypes[newChosenTextTypeIndex].name
            }
        }
    }
</script>

<style scoped>
    /* DocumentSettingsGenre-specific CSS goes here */
    .text-type {
        display: flex;
        margin: 10px;
    }
    .accordion-body-heading {
        margin: 0 0 5px;
    }
    .accordion-list {
        margin: 0 10px;
        padding: 0;
    }
</style>
